import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    this.boundHandleHidden = this.handleHidden.bind(this)
    this.modal = new Modal(this.element)
    this.element.addEventListener('hidden.bs.modal', this.boundHandleHidden)
    this.modal.show()
  }

  disconnect() {
    this.element.removeEventListener('hidden.bs.modal', this.boundHandleHidden)
    this.modal?.dispose()
  }

  hideBeforeRender(event) {
    if (this.isOpen()) {
      // alert('is open')
      event.preventDefault()
      this.element.addEventListener('hidden.bs.modal', event.detail.resume)
      this.modal.hide()
    }
  }

  isOpen() {
    return this.element.classList.contains("show")
  }

  close(event) {
    if (event.detail.success) {
      this.modal.hide()
    }
  }

  forceClose(event) {
    this.modal.hide()
  }

  handleHidden() {
    this.cleanupBackdropState()
  }

  cleanupBackdropState() {
    document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove())
    document.body.classList.remove('modal-open')
    document.body.style.removeProperty('padding-right')
  }

}
